module.exports = __webpack_public_path__ + "static/img/kb-phone-insurance.c6bff18.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kb-phone-insurance.jpg
// module id = KGTE
// module chunks = 0